module.exports = __webpack_public_path__ + "img/letterB.9d7297e0.svg";